/** Режимы работы навигатора */
export enum DxNavigatorModeType {
  TOP = 'TOP',
  SIDE = 'SIDE',
  TOP_SIDE = 'TOP_SIDE',
  NONE = 'NONE'
}
